import { toast } from "sonner";

/**
 * Copies text and reports the outcome, replacing the `executeJs("navigator.
 * clipboard.writeText")` calls the Vaadin grids used for their "Copy URL" cells.
 *
 * `navigator.clipboard` is unavailable on insecure origins and in some
 * embedded browsers, so there is a `execCommand` fallback rather than a silent
 * no-op.
 */
export async function copyText(text: string, okMessage = "Copied", errorMessage = "Copy failed") {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
    } else {
      const area = document.createElement("textarea");
      area.value = text;
      area.style.position = "fixed";
      area.style.opacity = "0";
      document.body.appendChild(area);
      area.select();
      document.execCommand("copy");
      document.body.removeChild(area);
    }
    toast.success(okMessage);
  } catch {
    toast.error(errorMessage);
  }
}
